











































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import copy from '@/utils/copy';

@Component
export default class DashboardComp extends Vue {
  @Prop() private rocketComps: any;
  @Prop() private compType: any;
  @Mutation('ADD_COMP') private ADD_COMP: any;
  private current: string = 'Global';
  private configMode: boolean = false;
  private config: string = '';
  private get tree() {
    const temp: any = {
      Global: [],
      Service: [],
      ServiceEndpoint: [],
      ServiceInstance: [],
      Proxy: [],
      ProxyEndpoint: [],
      ProxyInstance: [],
      Database: [],
    };
    this.rocketComps.data[this.compType].forEach((i: any) => {
      if (temp[i.o]) {
        temp[i.o].push(i);
      }
    });
    return temp;
  }
  private created() {
    this.config = JSON.stringify(this.rocketComps.tree);
  }
  private handleCopy(i: any) {
    copy(i);
  }
  private handleApply() {
    const r = confirm('');
    if (r === true) {
      window.localStorage.setItem('dashboard', this.config);
      this.configMode = false;
      location.reload();
    }
  }
  private handleReset() {
    const r = confirm('');
    if (r === true) {
      window.localStorage.removeItem('dashboard');
      this.configMode = false;
      location.reload();
    }
  }
}
